export default __webpack_public_path__ + "static/media/5.1c4b26af.jpg";